(() => {
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = (selector, direction = 'up') => {
    document.querySelectorAll(selector).forEach(el => {
      if (!el.hasAttribute('data-hm-reveal')) el.setAttribute('data-hm-reveal', direction);
    });
  };

  const stagger = (groupSelector, itemSelector) => {
    document.querySelectorAll(groupSelector).forEach(group => {
      if (!group.hasAttribute('data-hm-stagger')) group.setAttribute('data-hm-stagger', '');
      group.querySelectorAll(itemSelector).forEach(item => item.setAttribute('data-hm-stagger-item', ''));
    });
  };

  /*
   * Site-wide motion map.
   * Decorative only: no content is created here, and all source HTML remains
   * readable/crawlable without JavaScript.
   */
  document.querySelectorAll('.acc-reveal').forEach(el => el.setAttribute('data-hm-reveal','up'));

  [
    '.hc-callout',
    '.ab-values-hd', '.ab-team-hd', '.ab-cta',
    '.faq-contact',
    '.hto-card', '.hto-contact-strip',
    '.als-head', '.als-feature-split', '.als-cta',
    '.pl-head', '.pl-cta',
    '.sg-faq', '.sg-cta',
    '.blog-featured-card', '.blog-grid-hd', '.blog-cta',
    '.hsl-carousel-heading', '.hsl-facts-inner', '.hsl-section-title',
    '.hsl-application-grid', '.hsl-sustain-grid', '.hsl-faq-header',
    '.hsl-reviews-section'
  ].forEach(sel => reveal(sel,'up'));

  // Alternating editorial layouts.
  document.querySelectorAll('.ab-grid-2').forEach((el,index) => el.setAttribute('data-hm-reveal', index % 2 ? 'right' : 'left'));
  reveal('.ct-info-card','left');
  reveal('.ct-form-card','right');

  // Approved stagger language.
  stagger('.hc-grid','.hc-card');
  stagger('.hc-trust','.hc-trust-item');
  stagger('.ab-values-grid','.ab-value-card');
  stagger('.ab-team-grid','.ab-member');
  stagger('.hto-steps','.hto-step');
  stagger('.hto-trust','.hto-trust-item');
  stagger('.als-trust','.als-trust-item');
  stagger('.pl-formats-grid','.pl-format-card');
  stagger('.pl-steps','.pl-step');
  stagger('.pl-trust','.pl-trust-item');
  stagger('.sg-cards','.sg-card');
  stagger('.blog-grid','.blog-card');
  stagger('.hsr-grid','.hsr-card');
  stagger('.hsr-bs-grid','.hsr-card');
  stagger('.acc-trust','.acc-trust-cell');
  stagger('.acc-cts-grid','.acc-cts-card');
  stagger('.hsl-included-hero-grid','.hsl-inc-item');
  stagger('.hsl-ingredients-grid','.hsl-ingredient-row');
  stagger('.hsl-stats-grid','.hsl-stat-item');
  stagger('.hsl-faq-grid','.hsl-faq-item');

  const reveals = [...document.querySelectorAll('[data-hm-reveal]')];
  const groups = [...document.querySelectorAll('[data-hm-stagger]')];
  if (!reveals.length && !groups.length) return;

  groups.forEach(group => {
    [...group.querySelectorAll(':scope > [data-hm-stagger-item]')].forEach((item,index) => {
      item.style.setProperty('--hm-stagger-index', String(Math.min(index, 8)));
    });
  });

  const targets = [...reveals, ...groups];

  if (reduced || !('IntersectionObserver' in window)) {
    targets.forEach(el => el.classList.add('is-hm-visible'));
    return;
  }

  // Keep anything already in the initial viewport visible before enhancement
  // activates, avoiding LCP / first-paint flashes.
  const initialCutoff = window.innerHeight * .94;
  targets.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < initialCutoff) el.classList.add('is-hm-visible');
  });

  root.classList.add('hm-motion-ready');

  const observer = new IntersectionObserver((entries, io) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-hm-visible');
      io.unobserve(entry.target);
    });
  }, { threshold:.14, rootMargin:'0px 0px -7% 0px' });

  targets.forEach(el => {
    if (!el.classList.contains('is-hm-visible')) observer.observe(el);
  });
})();
